import React from "react";
import './returnOfUnclaimedGoodsLayout.scss';

const ReturnOfUnclaimedGoodsLayout = ({data}) => {
    return (
        <table className="table hover">
            <thead>
            <tr>
                <th scope="col" className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty'>Договор</p>
                </th>
                <th scope="col" className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty'>Наименование</p>
                </th>
                <th scope="col"
                    className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty unclaimedProperty-estimatedValue'>Цена реализации, руб.</p>
                </th>
                <th scope="col" className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty'>в том числе сумма наличных, руб.</p>
                </th>
                <th scope="col" className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty'>в том числе сумма по безналу, руб.</p>
                </th>
                <th scope="col" className='unclaimedProperty-tableItemHeader'>
                    <p className='unclaimedProperty'>в том числе сумма по ЕРИП, руб.</p>
                </th>
            </tr>
            </thead>
            <tbody>
            {data[0].deal.deal.map((i) => {
                return (<tr key={i.id}>
                    <td className='unclaimedProperty'>
                        <p className='unclaimedProperty'>{i.dealNumber}</p>
                    </td>
                    <td className='unclaimedProperty'>
                        <p className='unclaimedProperty'>{i.positions[0].names}</p>
                    </td>
                    <td>
                        <p className='unclaimedProperty unclaimedProperty-estimatedValue'>
                            {i.totalEstimatedValue.toFixed(2)}
                        </p>
                    </td>
                    <td>
                        <p className='unclaimedProperty'>{i.cash.toFixed(2) || 0}</p>
                    </td>
                    <td>
                        <p className='unclaimedProperty'>{i.nonCash.toFixed(2) || 0}</p>
                    </td>
                    <td>
                        <p className='unclaimedProperty'>{i.bankTransaction.toFixed(2) || 0}</p>
                    </td>
                </tr>);
            })}
            </tbody>
        </table>)
};

export default ReturnOfUnclaimedGoodsLayout;
